export const SET_NOTIFICATION_DRAWER_OPEN_REQUESTED =
  'SET_NOTIFICATION_DRAWER_OPEN_REQUESTED';
export const SET_NOTIFICATION_DRAWER_OPEN_COMPLETED =
  'SET_NOTIFICATION_DRAWER_OPEN_COMPLETED';
